export default __webpack_public_path__ + "static/media/Northword Lines3.af1b7196.png";